export const NotFound = () => {
  return (
    <div className="NotFound">
      <h2>404 Not Found</h2>
      <h1>GO TO</h1>
      <img src={require("../media/jail.png")} className="NotFound__img" />
      <h1>JAIL</h1>
    </div>
  );
};
